import { StorageRecord } from './types';

export const EXPIRABLE_KEY_SUFFIX = '_value';
export const EXPIRABLE_KEY_EXPIRATION_SUFFIX = '_expire';

export const getExpirationForDateTTL = (ttl: number) => new Date(Date.now() + ttl).toISOString();

export const createRecord = (value: StorageRecord) => JSON.stringify(value);

export const getExpirableItemKey = (key: string) => {
    return `${key}${EXPIRABLE_KEY_SUFFIX}`;
};

export const getExpirableItemExpirationKey = (key: string) => {
    return `${key}${EXPIRABLE_KEY_EXPIRATION_SUFFIX}`;
};
